//@ts-check
import React from 'react';
import Typography from '@material-ui/core/Typography';
import MissingValue from '../MissingValue';
import { isSpecified } from '../util';
import JourneyTouchpointIcon from './JourneyTouchpointIcon';
/**
 * @param {import('../types').FormatterProps<string> & { type?: 'touchpoint' | 'milestone', color?: string, isMilestone?: boolean }} props
 */

var JourneyTouchpoint = function JourneyTouchpoint(_ref) {
  var value = _ref.value,
      type = _ref.type,
      color = _ref.color,
      isMilestone = _ref.isMilestone,
      fallback = _ref.fallback;
  if (!isSpecified(value)) return fallback;
  if (!type) type = isMilestone ? 'milestone' : 'touchpoint';
  return React.createElement(Typography, {
    display: "inline",
    color: "inherit"
  }, React.createElement(JourneyTouchpointIcon, {
    value: type,
    color: color
  }), value);
};

JourneyTouchpoint.defaultProps = {
  isMilestone: false,
  fallback: React.createElement(MissingValue, null)
};
export default JourneyTouchpoint;